import React, { useState, useEffect } from "react";
import { createPortal } from "react-dom";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";

const BreadcrumbPortal = () => (
    <nav aria-label="Breadcrumb" id="breadcrumb" tabIndex={-1}></nav>
);

const Breadcrumb = ({ links, setOnApplyFilter }) => {
    const [portalNode, setPortalNode] = useState(null);
    
    useEffect(() => {
        setPortalNode(document.getElementById("breadcrumb"));
    }, []);

    const handleReportClick = () => {
        setOnApplyFilter?.(false);
    };

    return portalNode
    ? createPortal(
          <ol style={{ padding: 0 }}>
              {links.map((link, index) => (
                  <li
                      className={links.length === index + 1 ? "text-bold" : ""}
                      key={index}
                  >
                      {links.length === index + 1 ? (
                          <span aria-current="page">{link.name === "Dashboard" ? "Dashboards" : link.name}</span>
                      ) : link.path ? (
                          <Link
                              to={link.path}
                              onClick={
                                  link.name === "Reports"
                                      ? handleReportClick
                                      : undefined
                              }
                          >
                              {link.name}
                          </Link>
                      ) : (
                          <span>{link.name}</span>
                      )}
                  </li>
              ))}
          </ol>,
          portalNode
      )
    : null;

};

Breadcrumb.propTypes = {
    links: PropTypes.arrayOf(
        PropTypes.shape({
            name: PropTypes.string.isRequired,
            path: PropTypes.string,
        })
    ).isRequired,
    setOnApplyFilter: PropTypes.func,
};

export { Breadcrumb, BreadcrumbPortal };
